<div class="min-h-screen">
  <router-outlet />
</div>
